import { create } from 'zustand';

interface KeyboardState {
  isOpen: boolean;
  keyboardHeight: number;
  setKeyboardState: (isOpen: boolean, height: number) => void;
}

export const useKeyboardStore = create<KeyboardState>((set) => ({
  isOpen: false,
  keyboardHeight: 0,
  setKeyboardState: (isOpen, height) => set({ isOpen, keyboardHeight: height }),
}));
